import YFormCouponCodeTracking from './CouponCodeTracking';

export { YFormCouponCodeTracking };
export default YFormCouponCodeTracking;
